import axios from 'axios';

import Helpers from '@/classes/Helpers';
import global from '@/store/global';
import modal from '@/store/modal';

/**
 * Check if we have token in store or params. If not, redirect client to secv
 *
 * @param next
 * @param to
 */
export default function auth({ next, to }: any): any {
  // parse params
  const params: { [key: string]: string } = Helpers.paramsToObject(false);

  // get auth tokens. check both url params and store
  const authTokenParams = (params as any).access_token;
  const authTokenStore = global.authToken;

  // get cookies helper
  const cookies = (window as any).$cookies;

  // if we dont have auth token
  if (!authTokenParams && authTokenStore === '' && !params.code) {
    // grab cookie with referer and then remove that cookie
    const sourceCookie = cookies.get('_source') || '';
    cookies.remove('_source');

    // get unique uuid
    const csrf = Helpers.generateUUID();
    cookies.set('_csrf', csrf, '10MIN');

    // get b24 state
    const b24State = cookies.get('_b24state') || '';

    // create state param
    const stateParam = `${sourceCookie}||${csrf}||${b24State}`;

    // redirect url for secv
    const pathName = to.meta.secvReturn;
    let redirectUrl = window.location.origin + pathName;
    if (import.meta.env.NODE_ENV === 'development') {
      redirectUrl = `https://slsp.localhost:1234${pathName}`;
    }
    const redirectUrlParam = `&redirect_uri=${encodeURIComponent(redirectUrl)}`;

    // lang of app
    // https://jira.app.slsp.sk/browse/INC-41524 - pokial by bol lang paramter iny ako en alebo sk, CB by sa malo nacitat v slovencine
    const lang = params.lang === 'en' ? 'en' : 'sk';

    // get secv link a make redirect, or throw error
    const serverUrl =
      import.meta.env.NODE_ENV === 'development'
        ? 'http://localhost:6789/api/login'
        : '/api/login';

    axios({
      method: 'GET',
      url: serverUrl,
    })
      .then(async (response) => {
        if (response.status) {
          if (params.id_token) {
            // new auth approach - OIDC (implemented to support redirect from George Business)
            // handle getting code from it_token

            const codeVerifier = Helpers.generateCodeVerifier();
            const codeChallenge =
              await Helpers.generateCodeChallenge(codeVerifier);

            sessionStorage.setItem('code_verifier', codeVerifier);
            sessionStorage.setItem('id_token', params.id_token);
            sessionStorage.setItem('client_id', response.data.clientIdOidc);

            const additionalParams = `&id_token_hint=${params.id_token}&code_challenge=${codeChallenge}`;

            window.location.href =
              Helpers.getSetUrlParams(
                response.data.loginUrlOidc,
                'lang',
                lang,
              ) +
              stateParam +
              redirectUrlParam +
              additionalParams;

            return;
          }

          window.location.href =
            Helpers.getSetUrlParams(response.data.loginUrl, 'lang', lang) +
            stateParam +
            redirectUrlParam;
        } else {
          // original auth
          global.loaderOpened = false;
          modal.modalOpened = true;
          modal.modalType = 'techError';
        }
      })
      .catch(() => {
        global.loaderOpened = false;
        modal.modalOpened = true;
        modal.modalType = 'techError';
      });

    return undefined;
  }

  return next();
}
